import React from 'react'

const Footer = () => {
  return (
    <div className='p-10 bg-white border-t-2 flex justify-center items-center'>
      <p>
      © 2024 Solvexa Marketing.
      </p>
      
    </div>
  )
}

export default Footer
